import * as React from 'react';
import Navbar from '@/components/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import ProfileStepper from '@/components/profile/ProfileStepper';
import ProfileNavigation from '@/components/profile/ProfileNavigation';
import StepContent from '@/components/profile/StepContent';
import { ProfileProvider } from '@/components/profile/ProfileContext';
import { extractKiteRequestToken } from '@/utils/kiteConnect';
import { useToast } from '@/components/ui/use-toast';

const ProfileSetup = () => {
  const { toast } = useToast();
  const [kiteProcessed, setKiteProcessed] = React.useState(false);

  React.useEffect(() => {
    // Check if this is a callback from Zerodha Kite
    const handleKiteCallback = () => {
      const requestToken = extractKiteRequestToken();
      
      if (requestToken) {
        // Request token found, show success toast
        toast({
          title: "Zerodha Connected",
          description: "Successfully connected to your Zerodha account.",
          variant: "success"
        });
        
        // Clean up the URL to remove the token
        const cleanUrl = window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
        
        setKiteProcessed(true);
        return true;
      }
      
      // Check if there was an error stored from the Kite redirect
      const errorMessage = localStorage.getItem('kite_error_message');
      if (errorMessage) {
        toast({
          title: "Connection Failed",
          description: errorMessage,
          variant: "destructive"
        });
        
        // Clear the error message
        localStorage.removeItem('kite_error_message');
        setKiteProcessed(true);
        return true;
      }
      
      return false;
    };
    
    // Process Kite callback if applicable
    handleKiteCallback();
  }, [toast]);
  
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      
      <ProfileProvider>
        <div className="container mx-auto pt-24 px-4 pb-16">
          <div className="max-w-4xl mx-auto">
            {/* Progress Header */}
            <ProfileStepper className="mb-8" />
            
            {/* Main Content */}
            <Card className="bg-black border-[#9E7C47]/30">
              <CardContent className="p-6">
                <StepContent />
                
                {/* Navigation */}
                <ProfileNavigation />
              </CardContent>
            </Card>
          </div>
        </div>
      </ProfileProvider>
    </div>
  );
};

export default ProfileSetup;
